var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row text--base"},[(_vm.barTitle)?_c('BarChart',{attrs:{"content":_vm.barTitle}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }